import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Report_component_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="report_component_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Report Component Overview</h2>
              <p>
                Reports are a great way to quickly and easily see your data.
                Nexoid supports two types of reports.
              </p>

              <p>
                The first is a simple query report which allows for a predefined
                filtered search of an ElasticSearch index or table. Simple
                queries return one row per record. This allows for a link option
                giving the user the ability to navigate to the record editing
                page from the report.
              </p>

              <p>
                The second is an aggregate query. Aggregate queries are similar
                to the "group by" function in SQL. This gives you the ability to
                report on how many records fit specific criteria. For example,
                it could be a list of dates and a count of how many incident
                records were created on each date.
              </p>

              <p>
                Access to view reports is granted by the "System - Reports -
                Read" permission. Downloading report data is granted by the
                "System - Reports - CSV Download" permission. Individual reports
                and data are controlled by the standard object and record level
                permission.
              </p>
              <p>
                Reports are managed by administrators from the Settings -
                Reports pages. Reports are made up of a source (either a normal
                data object or a system object) and the report code. The report
                code is a JSON string defining the query, arguments, display
                output etc.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Report_component_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Report_component_overview.js